<template>
	<div>
		<h3>{{ $t('MAIN_CONTENT.General.passwordSettingsStartCase') }}</h3>
		<panel-basic v-if="!hasPassword" :title="$t( 'MAIN_CONTENT.General.changeMyPassword' )"
								id="passwordSettings"
								:collapsable="true"
								:headingLevel="4">
			<div class="row">
				<div class="col-xs-12" v-html="studentSSOMessage">
					
				</div>
			</div>
		</panel-basic>
		<panel-basic v-if="hasPassword" :title="$t( 'MAIN_CONTENT.General.changeMyPassword' )"
								id="passwordSettings"
								:collapsable="true"
								:headingLevel="4">
			<template slot="title">
				{{ $t('MAIN_CONTENT.General.changeMyPassword') }}
			</template>
			<div class="alert"
					:class="{'alert-success': passwordFields.responseType === 'success', 'alert-danger': passwordFields.responseType === 'danger'}"
					v-if="!!passwordFields.responseMessage">
				{{ passwordFields.responseMessage }}
			</div>
			<div class="row">
				<!-- PIN -->
				<div class="col-xs-6 col-md-4" v-if="(credType === 'LCLPWPIN')">
					<div class="row">
						<div class="col-xs-12">
							<strong>{{ $t('MAIN_CONTENT.General.pinWithColon') }}</strong>
						</div>
						<div class="col-xs-12">
							<input type="password" class="form-control" v-model="passwordFields.pin" maxlength="5">
						</div>
					</div>
				</div>
				<!-- Old Password -->
				<div class="col-xs-6 col-md-4">
					<div class="row">
						<div class="col-xs-12">
							<strong>{{ $t('MAIN_CONTENT.General.oldPasswordStartCaseWithColon') }}</strong>
						</div>
						<div class="col-xs-12">
							<input type="password" class="form-control" v-model="passwordFields.oldPassword" maxlength="30">
						</div>
					</div>
				</div>
			</div>
			<br />
			<div class="row">
				<!-- New Password -->
				<div class="col-xs-6 col-md-4">
					<div class="row">
						<div class="col-xs-12">
							<strong>
								{{ $t('MAIN_CONTENT.General.newPasswordStartCaseWithColon') }}
							</strong>
						</div>
						<div class="col-xs-12 userWizard">
							<password
								name="password"
								ref="password" 
								class="password-input"
								v-model="passwordFields.newPassword"
								:toggle="true"
								:secureLength="passwordMinLegth"
								:showStrengthMeter="true"
								autocomplete="new-password"
								maxlength="40"
								:disabled="(credType === 'LCLPWPIN' && !passwordFields.pin) || !passwordFields.oldPassword"
							/>
						</div>
					</div>
				</div>
				<!-- Confirm New Password -->
				<div class="col-xs-6 col-md-4">
					<div class="row">
						<div class="col-xs-12">
							<strong>
								{{ $t('MAIN_CONTENT.General.confirmNewPasswordStartCaseWithColon') }}
							</strong>
						</div>
						<div class="col-xs-12 userWizard">
							<password
								name="password"
								ref="password" 
								class="password-input"
								v-model="passwordFields.confirmNewPassword"
								:toggle="true"
								:secureLength="passwordMinLegth"
								:showStrengthMeter="true"
								autocomplete="new-password"
								maxlength="40"
								:disabled="(credType === 'LCLPWPIN' && !passwordFields.pin) || !passwordFields.oldPassword"
							/>
							<small v-if="((credType !== 'LCLPWPIN' || passwordFields.pin) && passwordFields.oldPassword) && passwordFields.newPassword.length > 0 && passwordMessage > 0" class="help-block text-danger" >
								<span v-if="passwordMessage === 1">
									{{ $t( 'MAIN_CONTENT.General.passwordRequirements' ) }}
									<ul>
										<li>{{ $t( 'MAIN_CONTENT.General.passwordLengthMessage', { length: passwordMinLegth } ) }}</li>
										<li>{{ $t( 'MAIN_CONTENT.General.passwordMixMessage' ) }}</li>
									</ul>
								</span>
								
								<span v-if="passwordMessage === 2">{{ $t( 'MAIN_CONTENT.General.passwordDoesntMatch' ) }}</span>
							</small>
						</div>
					</div>
				</div>
			</div>
			<br />
			<div class="row">
				<div class="col-xs-4 col-xs-offset-4">
					<button class="btn btn-default"
									@click="saveNewPassword"
									:disabled="((credType === 'LCLPWPIN' && !passwordFields.pin) || !passwordFields.oldPassword) || passwordFields.newPassword !== passwordFields.confirmNewPassword || passwordMessage !== 0">
						{{ $t('commonText.save') }}
					</button>
				</div>
			</div>
		</panel-basic>

		<h3 v-if="hasPassword">{{ $t('MAIN_CONTENT.General.securityQuestionSettingsStartCase') }}</h3>
		<panel-basic v-if="hasPassword" :title="$t( 'MAIN_CONTENT.General.changeMySecurityQuestion' )"
								id="securityQuestionSettings"
								:collapsable="true"
								:headingLevel="4">
			<template slot="title">
				{{ $t('MAIN_CONTENT.General.changeMySecurityQuestion') }}
			</template>
			<div class="alert"
					:class="{'alert-success': securityQuestionFields.responseType === 'success', 'alert-danger': securityQuestionFields.responseType === 'danger'}"
					v-if="!!securityQuestionFields.responseMessage">
				{{ securityQuestionFields.responseMessage }}
			</div>
			<div class="row">
				<!-- Security Question -->
				<div class="col-xs-12">
					<strong>
						{{ $t('MAIN_CONTENT.General.securityQuestionStartCaseWithColon') }}
					</strong>
				</div>
				<div class="col-xs-12">
					<input type="text" class="form-control" v-model="securityQuestionFields.question" maxlength="100">
				</div>
			</div>
			<br />
			<!-- security Answer -->
			<div class="row">
				<div class="col-xs-12">
					<strong>
						{{ $t('MAIN_CONTENT.General.securityAnswerStartCaseWithColon') }}
					</strong>
				</div>
				<div class="col-xs-12">
					<input type="text" class="form-control" v-model="securityQuestionFields.answer" maxlength="100">
				</div>
			</div>
			<br />
			<div class="row">
				<div class="col-xs-4 col-xs-offset-4">
					<button class="btn btn-default"
									@click="saveSecurityQuestions"
									:disabled="!securityQuestionFields.question || !securityQuestionFields.answer">
						{{ $t('commonText.save') }}
					</button>
				</div>
			</div>
		</panel-basic>

		<!-- Language Selection -->
		<h3>{{ $t('MAIN_CONTENT.General.generalAccountSettings') }}</h3>
		<panel-basic :title="$t( 'MAIN_CONTENT.General.changeMyAccountSettings' )"
								id="generalAccountSettings"
								:collapsable="true"
								:headingLevel="4">
			<template slot="title">
				{{ $t('MAIN_CONTENT.General.changeMyAccountSettings') }}
			</template>
			<div class="alert"
					 :class="{'alert-success': generalAccountSettings.responseType === 'success', 'alert-danger': generalAccountSettings.responseType === 'danger'}"
					 v-if="!!generalAccountSettings.responseMessage">
				{{ generalAccountSettings.responseMessage }}
			</div>
			<div class="row">
				<!-- Language Selection -->
				<div class="col-xs-12">
					<strong>
						{{ $t('MAIN_CONTENT.General.selectLanguage') }}
					</strong>
				</div>
				<div class="col-xs-12">
					<select name="localeSelection" id="localeSelect" class="form-control" v-model="selectedLocale">
						<option v-for="( locale, localeIndex ) in locales"
										:value="locale.LOCALE_ID"
										:key="`locale_${localeIndex}`">
							{{ locale.LOCALE_DISPLAY_TEXT }}
						</option>
					</select>
				</div>
			</div>
			<br />
			<div class="row">
				<div class="col-xs-4 col-xs-offset-4">
					<button class="btn btn-default"
									@click="saveAccountSettings">
						{{ $t('commonText.save') }}
					</button>
				</div>
			</div>
		</panel-basic>
	</div>
</template>

<script>
	import Profile from '../../api/Profile';
	import Locales from '../../api/Locales';
	import { mapGetters } from 'vuex';
	import PanelBasic from 'COMMONS/panels/PanelBasic.vue';
	import Password from 'vue-password-strength-meter'
	import DistrictImage from '../../api/DistrictImage';

	export default {
		data() {
			return {
				passwordFields: {
					pin: '',
					oldPassword: '',
					newPassword: '',
					confirmNewPassword: '',
					responseType: '',
					responseMessage: ''
				},
				securityQuestionFields: {
					question: this.$store.state.profile.USER_QUESTION,
					answer: this.$store.state.profile.USER_ANSWER,
					responseType: '',
					responseMessage: ''
				},
				generalAccountSettings: {
					locale: '',
					responseType: '',
					responseMessage: ''
				},
				studentSSOMessage:"",
				passwordMinLegth: 8,
				selectedLocale: '',
				locales: []
			};
		},
		components: {
			PanelBasic, 
			Password
		},
		computed: {
			...mapGetters(['credType', 'userID', 'profileLocale', 'userIsAdmin', 'getSelectedLocale']),
			hasPassword(){
				return !this.$store.state.profile.hasOwnProperty('HASPASSWORD') || this.$store.state.profile.HASPASSWORD;
			},
			allPasswordFields() {
				return (this.credType === "" || this.passwordFields.pin) + this.passwordFields.oldPassword + this.passwordFields.newPassword + this.passwordFields.oldPassword + this.passwordFields.confirmNewPassword;
			},
			allSecurityQuestionFields() {
				return this.securityQuestionFields.answer;
			},
			passwordMessage(){
				let alpha = /[a-zA-Z]/,
				number = /[0-9]/,
				minLength = this.passwordMinLegth;
				/* check length */
				if(this.passwordFields.newPassword.length < minLength){
					return 1;
				}
				/* Check A mixture of letters and numbers */
				else if(!alpha.test(this.passwordFields.newPassword) || !number.test(this.passwordFields.newPassword)){
					return 1;
				}
				/* Make sure confirm password matches */
				else if(this.passwordFields.newPassword !== this.passwordFields.confirmNewPassword){
					return 2;
				}
				/* else basic check password change is good */
				return 0;
			}
		},
		watch: {
			allPasswordFields(newValue, oldValue){
				if( oldValue === '' ){
					this.passwordFields.responseType = '';
					this.passwordFields.responseMessage = '';
				}
			},
			allSecurityQuestionFields(newValue, oldValue){
				if( oldValue === '' ){
					this.securityQuestionFields.responseType = '';
					this.securityQuestionFields.responseMessage = '';
				}
			}
		},
		methods: {
			resetPasswordFields(){
				this.passwordFields.pin = '';
				this.passwordFields.oldPassword = '';
				this.passwordFields.newPassword = '';
				this.passwordFields.confirmNewPassword = '';
			},
			resetSecurityQuestionFields(){
				this.securityQuestionFields.answer = '';
			},
			saveNewPassword() {
				const self = this;

				let profile = new Profile({
					routeParams: { setting: 'password' },
					data: {
						'password': this.passwordFields.oldPassword,
						'new_password': this.passwordFields.newPassword,
						'pin': this.passwordFields.pin,
						'new_password_confirm': this.passwordFields.confirmNewPassword,
						'user_id':this.userID
					}
				});

				const promise = profile.put();
				promise.then(response => {
					self.passwordFields.responseType = profile.getResponseMessages()[0].TYPE;
					self.passwordFields.responseMessage = profile.getResponseMessages()[0].TEXT;
					self.resetPasswordFields();

					if( !profile.getResponseError() ){
						self.$store.dispatch('logoutOtherDevices');
					}
				})
				.catch(error => {
					self.resetPasswordFields();
				});
			},
			saveSecurityQuestions() {
				const self = this;

				let profile = new Profile({
					routeParams: { setting: 'security-question' },
					data: {
						"user_question": self.securityQuestionFields.question,
						"user_answer": self.securityQuestionFields.answer
					}
				});

				const promise = profile.put();

				promise.then(response => {
					self.securityQuestionFields.responseType = profile.getResponseData().TYPE;
					self.securityQuestionFields.responseMessage = profile.getResponseData().TEXT;

					if(profile.getResponseData().TYPE === 'success') {
						self.resetSecurityQuestionFields();
					}
				})
				.catch(error => {
					self.resetSecurityQuestionFields();
				});
			},
			fetchLocaleList() {
				const self = this;

				let locales = new Locales({});

				locales.get().then(response => {
					self.locales = locales.getResponseData();
				})
				.catch(error => {
					self.locales = [];
				});
			},
			checkIfHasPw(){
				
			},
			saveAccountSettings() {
				const self = this;
				const selectedLocaleOption = this.locales.find( locale => this.selectedLocale === locale.LOCALE_ID );

				let profile = new Profile({
					routeParams: { setting: 'locale' },
					data: {
						'locale': selectedLocaleOption.LOCALE_ID,
						'user_id': this.userID
					}
				});

				const promise = profile.put();

				promise.then(response => {
					self.generalAccountSettings.responseType = profile.getResponseData().TYPE;
					self.generalAccountSettings.responseMessage = profile.getResponseData().TEXT;

					if( profile.getResponseData().TYPE === 'success' ) {
						self.$store.state.profile.LOCALE = JSON.parse( JSON.stringify( selectedLocaleOption ) );
						self.$i18n.locale = selectedLocaleOption.LOCALE_CODE;
						
						let localeId = 
							selectedLocaleOption.LOCALE_CODE !== 'sa-US' 
							&& selectedLocaleOption.LOCALE_CODE !== 'en-US' 
								? this.getSelectedLocale.LOCALE_CODE 
								: 'en-US';
						
						document.documentElement.setAttribute('lang', localeId); 

						selectedLocaleOption.LOCALE_CODE !== 'sa-US' && 
						selectedLocaleOption.LOCALE_CODE !== 'en-US' ? 
							moment.locale( this.getSelectedLocale.LOCALE_CODE ) : 
							moment.locale( 'en' );
					}

					self.resetPasswordFields();
				})
				.catch(error => {
					self.resetPasswordFields();
				});
			},
			getStudentSSOMessage(){
				this.studentSSOMessage = "";
				const self = this;
				
				const district = new DistrictImage({});

				const promise = district.get();

				promise.then(response => {
					let data = district.getResponseData();
					this.studentSSOMessage = data.STUDENT_SSO_MESSAGE;
				});
			}
		},
		created() {
			this.$store.commit('setTitleIcon', 'cog');
			this.$store.commit('setTitle', 'MAIN_CONTENT.General.general');
			this.$store.commit('setUseHeader', true);

			if( this.userIsAdmin ) {
				this.$router.push({ name: 'HomePage' });
			}
			
			if( Object.keys( this.profileLocale ).length > 0 ) {
				this.selectedLocale = this.profileLocale.LOCALE_ID;
			}

			this.fetchLocaleList();
			this.getStudentSSOMessage();
		}
	}
</script>
